module.exports = __webpack_public_path__ + "static/media/article-img.ddad0bf0.png";